import React from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import connect from 'react-redux/es/connect/connect';
import Flickity from 'react-flickity-component';
import MediaQuery from 'react-responsive';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import { renderField } from '../../Inputs';
import Progress from '../../Progress';
import UpdateAuditC from '../../../Actions/Register/updateAuditC';

import pintImg from '../../../images/pint.svg';
import beerBottleImg from '../../../images/beer-bottle.svg';
import smallWineImg from '../../../images/wine-small.svg';
import largeWineImg from '../../../images/wine-large.svg';
import bottleWineImg from '../../../images/wine-bottle.svg';
import shotImg from '../../../images/shot.svg';

const required = value => (value || typeof value === 'number' ? undefined : 'Required');
const number = value => (value && isNaN(Number(value)) ? 'Must be a number' : undefined);

const parsers = {
  number: (value) => {
    let result;
    if (new RegExp(/^\d*$/g).test(value) && !(value.indexOf('.') > -1) && value.length > 3) {
      result = parseInt(value.substring(0, 3), 10) <= 999 ? value.substring(0, 3) : '';
    }

    if (value) {
      return new RegExp(/^([0-9]|[1-9][0-9]|[1-9][0-9][0-9])$/g).test(value) ? value : result;
    }
    return '';
  },
};

const aboveZero = (value) => {
  if (value < 0) {
    return 0;
  }
  return value;
};

const carouselOpts = {
  wrapAround: false,
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  prevNextButtons: false,
  // watchCSS: true,
  imagesLoaded: true,
};

class Alcohol extends React.PureComponent {
  state = {
    units_per_week: this.props.units,
  };

  componentWillMount() {
    this.updateScore();
  }

  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.auditc) !== JSON.stringify(prevProps.auditc)) {
      this.updateScore();
    }
  }

  updateScore(o) {
    const lState = { ...this.props.auditc };

    lState.score = 0;
    lState.showMessage = 0;
    lState.answered = 0;

    if (lState.no_of_drinks) {
      lState.answered += 1;
      switch (lState.no_of_drinks) {
        case '01-02':
        case '1-2':
          lState.score += 0;
          lState.showMessage += 1;
          break;
        case '03-04':
        case '3-4':
          lState.score += 1;
          lState.showMessage += 1;
          break;
        case '5-6':
        case '05-06':
          lState.score += 2;
          lState.showMessage += 1;
          break;
        case '07-09':
        case '7-9':
          lState.score += 3;
          lState.showMessage += 1;
          break;
        case '10+':
          lState.score += 4;
          lState.showMessage += 1;
          break;
        default:
      }
    }

    if (lState.six_or_more) {
      lState.answered += 1;
      switch (lState.six_or_more.toLowerCase()) {
        case 'never':
          lState.showMessage += 1;
          break;
        case 'less than monthly':
          lState.score += 1;
          lState.showMessage += 1;
          break;
        case 'monthly':
          lState.score += 2;
          lState.showMessage += 1;
          break;
        case 'weekly':
          lState.score += 3;
          lState.showMessage += 1;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          lState.showMessage += 1;
          break;
        default:
      }
    }

    if (lState.drink_frequency) {
      lState.answered += 1;
      switch (lState.drink_frequency.toLowerCase()) {
        case 'never':
          lState.showMessage += 1;
          break;
        case 'monthly or less':
          lState.score += 1;
          lState.showMessage += 1;
          break;
        case '2-4 times per month':
          lState.score += 2;
          lState.showMessage += 1;
          break;
        case '2-3 times per week':
          lState.score += 3;
          lState.showMessage += 1;
          break;
        case '4+ times per week':
          lState.score += 4;
          lState.showMessage += 1;
          break;
        default:
      }
    }

    this.setState(lState);

    this.props.dispatch(change('registration', 'assessment[alcohol_score]', lState.score));
  }

  render() {
    const { previousPage, handleSubmit } = this.props;

    return (
      <Row classes="drinking-less" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Progress step="alcohol" />
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="100" height="100" />
        </Paragraph>
        <Heading classes="header-text yellow" center><span id="register8">Drink less</span></Heading>
        <Paragraph classes="width-limited" center>Many alcohol-related health risks {"don't"} appear until later in life.</Paragraph>
        <Paragraph classes="width-limited" center>Cutting down on how much alcohol you drink will reduce your risk of developing serious health issues such as cancer, liver or heart disease and could contribute to lowering your blood pressure.
        </Paragraph>
        <Heading tag="h3" classes="header-text units-guide-title" center>Unit guide</Heading>
        <MediaQuery minWidth={769}>
          {(matches) => {
            const Component = matches ? 'div' : Flickity;

            return (
              <Component className="units-guide-carousel" options={carouselOpts} static>
                <div key={0} className="carousel-item">
                  <Paragraph classes="unit-type">Pint of <br /> Beer / Cider</Paragraph>
                  <img src={pintImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">2.2 units</Paragraph>
                </div>
                <div key={1} className="carousel-item">
                  <Paragraph classes="unit-type">Bottle of <br /> Beer / Cider</Paragraph>
                  <img src={beerBottleImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">1.5 units</Paragraph>
                </div>
                <div key={2} className="carousel-item">
                  <Paragraph classes="unit-type">Small Glass of <br /> Wine</Paragraph>
                  <img src={smallWineImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">2.2 units</Paragraph>
                </div>
                <div key={3} className="carousel-item">
                  <Paragraph classes="unit-type">Large Glass of <br /> Wine</Paragraph>
                  <img src={largeWineImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">3 units</Paragraph>
                </div>
                <div key={4} className="carousel-item">
                  <Paragraph classes="unit-type">Bottle of <br /> Wine</Paragraph>
                  <img src={bottleWineImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">9.8 units</Paragraph>
                </div>
                <div key={5} className="carousel-item">
                  <Paragraph classes="unit-type">Shot of <br /> Spirit</Paragraph>
                  <img src={shotImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">1 unit</Paragraph>
                </div>
              </Component>
            );
          }}
        </MediaQuery>
        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text alcohol-unit-section" center><strong>Roughly how many units of alcohol do you currently drink each week?</strong></Paragraph>
          <Field
            name="assessment[alcohol_units_per_week]"
            type="text"
            component={renderField}
            validate={[required, number]}
            centered
            normalize={aboveZero}
            parse={parsers.number}
            classes="text-input-field"
            onChange={(e, v) => this.props.dispatch(UpdateAuditC('units_per_week', v))}
          />

          {this.state.units_per_week > 0 || this.props.auditc.units_per_week > 0 ? (
            <div>
              <Paragraph classes="section-text" center><strong>How many UNITS OF ALCOHOL do you drink on a typical day when you are drinking?</strong></Paragraph>
              <Field
                name="assessment[alcohol_no_of_drinks]"
                type="radiogroup"
                component={renderField}
                params={{ dataKey: 'auditCUnits', name: 'assessment[alcohol_no_of_drinks]', classes: 'yellow fiveInRow' }}
                validate={[required]}
                centered
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('no_of_drinks', v))}
              />

              {this.state.answered >= 1 || this.props.auditc.no_of_drinks ? [
                <Paragraph key={0} classes="section-text" center><strong>How often do you have a drink containing alcohol?</strong></Paragraph>,
                <Field
                  key={1}
                  name="assessment[alcohol_drink_frequency]"
                  type="radiogroup"
                  component={renderField}
                  params={{ dataKey: 'auditCFreq', name: 'assessment[alcohol_drink_frequency]', classes: 'yellow fiveInRow' }}
                  validate={[required]}
                  centered
                  onChange={(e, v) => this.props.dispatch(UpdateAuditC('drink_frequency', v))}
                />,
              ] : null}

              {this.state.answered >= 2 || this.props.auditc.six_or_more ? [
                <Paragraph classes="section-text" center><strong>How often do you have six or more drinks on one occasion?</strong></Paragraph>,
                <Field
                  name="assessment[alcohol_six_or_more]"
                  type="radiogroup"
                  component={renderField}
                  params={{ dataKey: 'auditCFreqLong', name: 'assessment[alcohol_six_or_more]', classes: 'yellow fiveInRow' }}
                  validate={[required]}
                  centered
                  onChange={(e, v) => this.props.dispatch(UpdateAuditC('six_or_more', v))}
                />,
              ] : null}

              {this.state.score >= 5 ? [
                <Paragraph classes="section-text" center><strong>Your score shows that you may benefit from answering a few more questions to better understand how your drinking habits might be impacting you.<br />Are you happy to continue with these questions?</strong></Paragraph>,
                <Field
                  name="assessment[alcohol_more_question]"
                  type="radiogroup"
                  component={renderField}
                  params={{ dataKey: 'LeaveMessage', name: 'assessment[alcohol_more_question]', classes: 'yellow' }}
                  validate={[required]}
                  centered
                  onChange={(e, v) => this.props.dispatch(UpdateAuditC('more_question', v))}
                />,
              ] : null}
            </div>
          ) : null}
          {this.props.auditc.six_or_more ? [
            <Paragraph classes="section-text" center><strong>Would you like help to drink less?</strong></Paragraph>,
            <Field name="pathway_alcohol" type="radiogroup" params={{ dataKey: 'LeaveMessage', classes: 'yellow textUppercase' }} component={renderField} centered />,
                ] : null }
          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button yellow']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={previousPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

Alcohol.propTypes = {
  previousPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  auditc: PropTypes.object.isRequired,
};

const AlcoholForm = connect(state => ({
  auditc: state.auditc || {},
}))(Alcohol);

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AlcoholForm);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Alcohol.jsx